import { View } from "react-native";
import { Button } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import CardText from "../../CardText";

type Props = {
  errorMessage: string;
  onEditPress: () => void;
};

export default function EditBankAccount({ errorMessage, onEditPress }: Props) {
  const tailwind = useTailwind();

  return (
    <View style={tailwind("flex-row mt-3")}>
      <CardText.Body
        text={errorMessage}
        error
        style={tailwind("flex-1 mr-3")}
      />
      <Button
        mode="contained-tonal"
        onPress={onEditPress}
        style={tailwind("self-center")}
      >
        Editar cuenta
      </Button>
    </View>
  );
}
